// extracted by mini-css-extract-plugin
module.exports = {"promoCard":"promoSection_promoCard__1Qnep"};